import { NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Inject,
  Input,
  OnChanges,
  Renderer2,
  SimpleChanges,
  TemplateRef,
} from '@angular/core';
import { WINDOW } from '@ng-web-apis/common';

@Component({
  selector: 'sharry-masonry-grid',
  standalone: true,
  imports: [NgTemplateOutlet],
  template: `
    <section class="masonry-grid">
      @for (item of reorderedElements; track item) {
        <ng-container
          [ngTemplateOutlet]="masonryTemplate"
          [ngTemplateOutletContext]="{ $implicit: item }"></ng-container>
      }
    </section>
  `,
})
export class MasonryGridComponent implements OnChanges {
  @Input() masonryGrid: { lg: number; md: number; sm: number; xs: number } = { lg: 3, md: 3, sm: 2, xs: 1 };
  @Input() masonryElements: any[] = [];
  @Input() masonryTemplate: TemplateRef<any>;
  @Input() higherHeight = 250;

  reorderedElements: any[] = [];

  constructor(
    @Inject(WINDOW) private window: Window,
    private el: ElementRef<HTMLElement>,
    private renderer: Renderer2,
    private cd: ChangeDetectorRef,
  ) {}

  @HostListener('window:resize') onResize() {
    this.setElements();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.masonryElements?.currentValue?.length) {
      this.setElements();
    }
  }

  private setElements() {
    this.renderer.setStyle(
      this.el.nativeElement.firstElementChild,
      'column-count',
      this.masonryGrid[this.matchMedia()],
    );
    this.reorder(this.masonryElements, this.masonryGrid[this.matchMedia()]);
    Array.from(this.el.nativeElement.firstElementChild.children).forEach(item => {
      this.renderer.setStyle(item, '-webkit-column-break-inside', 'avoid');
      this.renderer.setStyle(item, 'break-inside', 'avoid');
      this.renderer.setStyle(item, 'page-break-inside', 'avoid');
      const id = item.getAttribute('id');
      if (!id || id?.startsWith('temp-')) {
        this.renderer.setStyle(item, 'opacity', '0');
        this.renderer.setStyle(item, 'height', this.higherHeight + 'px');
        this.renderer.setStyle(item, 'display', 'none');
      }
    });
  }

  private matchMedia() {
    const toSize = (n: number) => {
      switch (n) {
        case 500:
          return 'xs';
        case 900:
          return 'sm';
        case 1023:
          return 'md';
        default:
          return 'lg';
      }
    };
    const breakPoints = [500, 900, 1023];
    return toSize(breakPoints.find(width => !!this.window.matchMedia(`(max-width: ${width}px)`).matches));
  }

  private reorder(arr: any[], columns: number) {
    const cols = columns;
    const list = [...arr.map((a, i) => ({ ...a, id: a.id || `${i}` })).filter(c => !c.id.startsWith('temp-'))];
    while (list.length % cols !== 0) {
      list.push({ id: `temp-${Math.random()}` });
    }
    const out = [];
    let col = 0;
    while (col < cols) {
      for (let i = 0; i < list.length; i += cols) {
        const _val = list[i + col];
        if (_val !== undefined) out.push(_val);
      }
      col++;
    }
    this.reorderedElements = out;
    this.cd.detectChanges();
  }
}
